export const ARTICLES_OPTION_CODENAME = 'articles';
export const PEOPLE_OPTION_CODENAME = 'profiles';
export const ARTICLE_TYPE_OPTION_CODENAME = 'article_type';
export const YEAR_OPTION_CODENAME = 'year';
export const LOCATION_OPTION_CODENAME = 'content_type__location';
export const PRACTICE_AREA_OPTION_CODENAME = 'content_type__practice_areas';
export const PUBLISHER_OPTION_CODENAME = 'content_type__publisher';
export const FILTER_OPTION_TYPE_TAXONOMY = 'taxonomy';
export const FILTER_OPTION_TYPE_LINKED_ITEMS = 'linked_items';
